
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    forId: {
      type: String,
      required: true
    }
  }
});
